import React from "react";
import * as S from "./styled";
import { IconWrap, ItemWrap } from "_c/modules/landing/EnumeratedFeature";
import { SectHead } from "../styled";
import range from "lodash/range";

const amount = 4;
export default ({ t }) => {
  return (
    <S.Wrap>
      <SectHead>
        <h3>{t("titles.3")}</h3>
        <span>{t("subtitles.3")}</span>
      </SectHead>
      <S.List>
        {range(1, amount + 1).map((n) => (
          <ItemWrap key={n}>
            <IconWrap>
              <img src={`/svg/services-${n}.svg`} alt="" />
            </IconWrap>
            <span>{t(`advantages.${n}`)}</span>
          </ItemWrap>
        ))}
      </S.List>
    </S.Wrap>
  );
};
